import { request } from '../../utils/request';
import { ResponseGetLocation } from '../../app/ApiGen';

export type Response = ResponseGetLocation;

export const getLocation: (id: string) => Promise<Response> = async (id: string) =>
  request<ResponseGetLocation>(`/locations/${id}`, { method: 'GET' });
